export const GET_BAZAAR_CUSTOMERS = "GET_BAZAAR_CUSTOMERS";
export const GET_BAZAAR_CUSTOMER_BY_ID = "GET_BAZAAR_CUSTOMER_BY_ID";
export const UPDATE_BAZAAR_CUSTOMER = "UPDATE_BAZAAR_CUSTOMER";
export const DELETE_BAZAAR_CUSTOMER = "DELETE_BAZAAR_CUSTOMER";
export const CREATE_BAZAAR_CUSTOMER = "CREATE_BAZAAR_CUSTOMER";
export const GET_BAZAAR_CURRENT_CUSTOMER = "GET_BAZAAR_CURRENT_CUSTOMER";
export const GET_BAZAAR_CUSTOMER_FULL = "GET_BAZAAR_CUSTOMER_FULL";
